import useCurrentUser from "hooks/useCurrentUser";
import React, { useEffect, useCallback } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Loader from "./Loader";

const ProtectedRoutes = () => {
    const location = useLocation();
    const { pathname } = location;

    const token = localStorage.getItem("token");
    const { setToken, user: currentUser, loading, socket } = useCurrentUser();
    const { pilotProfileCompletedSteps, roleType, isStripeConnected } =
        currentUser || {};

    // Safe step parsing
    const currentStep = Number(pilotProfileCompletedSteps) || 0;
    const nextStep = Math.min(currentStep + 1, 3);
    // Sync token with context
    useEffect(() => {
        if (setToken) setToken(token || undefined);
    }, [token, setToken]);

    // Socket reload handler
    const handlePaymentResponse = useCallback(
        (data) => {
            const type = data?.data?.type;

            if (type === "Job" && pathname.includes("my-jobs")) {
                window.location.reload();
            } else if (
                type === "Emergency" &&
                (pathname.includes("emergency") ||
                    pathname.includes("disasterdetails") ||
                    pathname.includes("missingdetails"))
            ) {
                window.location.reload();
            } else if (
                type === "SponsorRequest" &&
                (pathname.includes("emergency") ||
                    pathname.includes("advertisement"))
            ) {
                window.location.reload();
            }
        },
        [pathname]
    );

    useEffect(() => {
        if (!socket) return;

        socket.on("paymentResponse", handlePaymentResponse);

        return () => {
            socket.off("paymentResponse", handlePaymentResponse);
        };
    }, [socket, handlePaymentResponse]);

    // ───────────────────────────────────────────────
    //   1️⃣ Loading check BEFORE redirect logic
    // ───────────────────────────────────────────────
    if (loading) return <Loader loading={loading} />;

    // ───────────────────────────────────────────────
    //   2️⃣ Token required
    // ───────────────────────────────────────────────
    if (!token) return <Navigate to="/" />;

    // ───────────────────────────────────────────────
    //   3️⃣ PILOT role-specific routing
    // ───────────────────────────────────────────────
    if (roleType === "PILOT" && !pathname.includes("verify-otp")) {
        const isProfileRoute = pathname.includes("profileStep");

        // --- A) Allow access to profile steps but prevent skipping ---
        if (isProfileRoute) {
            console.log('isProfileRoute')
            const stepInUrl = parseInt(pathname.replace("/profileStep", ""), 10);
            console.log("+++stepInUrl", stepInUrl)
            // prevents jumping ahead
            if (stepInUrl > nextStep) {
                console.log('stepInUrl > nextStep')
                return <Navigate to={`/profileStep${nextStep}`} />;
            }

            return <Outlet />;
        }

        // --- B) If steps incomplete → go to correct step ---
        if (currentStep < 3) {
            console.log('currentStep < 3')
            return <Navigate to={`/profileStep${nextStep}`} />;
        }

        // --- C) Steps complete but Stripe not connected ---
        if (currentStep === 3 && !isStripeConnected) {
            const isHomeRoute = pathname === "/";
            const isConnectRoute = pathname.includes("connect");

            // Allow HOME and CONNECT route only
            if (isHomeRoute || isConnectRoute) {
                return <Outlet />;
            }
            // Block every other route → Send to connect page
            return <Navigate to="/connect" />;
        }

    }

    // ───────────────────────────────────────────────
    //   4️⃣ Default: allow route
    // ───────────────────────────────────────────────
    return <Outlet />;
};

export default ProtectedRoutes;
